import React from 'react';
import { DependencyManagerProvider } from 'src/contexts/dependencyManager';
import { OrdersPage } from '../pages/Orders';
import '../styles/global.scss';
import * as T from './types';
import { BackgroundProcess } from '@uma/react-commons/dist/index';

const App: React.FC<T.AppPropsType> = () => {
  return (
    <>
      <BackgroundProcess />
      <DependencyManagerProvider>
        <OrdersPage />
      </DependencyManagerProvider>
    </>
  );
};

export default App;
